<template>
  <div
    v-tinymce="options"
    :key="renderKey"
    @mce-change="(table) => offerSectionSet({ pricingTable: table })"
    @mce-dirty="() => $emit('dirty')"
  >
    <div
      v-if="offerSections.pricingTable"
      v-html="offerSections.pricingTable"
    ></div>
    <b-card v-else>
      <h4>{{ $t('pricing.offer') }}</h4>
      <table class="table mt-4">
        <tbody>
          <tr class="highlight-row">
            <td><strong>{{ $t('pricing.services') }}</strong></td>
            <td><strong>{{ $t('pricing.quantity') }}</strong></td>
            <td><strong>{{ $t('pricing.unitPrice') }}</strong></td>
            <td>
              <strong>{{ $t('pricing.totalPrice') }}<br /></strong>{{ $tc('pricing.participants', capacity, { count: capacity }) }}
            </td>
          </tr>
          <tr>
            <td>
              {{ offer && offer.title ? offer.title : seminarTitle }}
              <span v-if="numberOfExecutions > 1"><br />{{ $t('pricing.executions', { count: numberOfExecutions }) }}
              </span>
            </td>
            <td v-if="isOpenSeminar">{{ $tc('pricing.participants', capacity, { count: capacity }) }}</td>
            <td v-else>{{ duration }}</td>
            <td>
              {{ dailyPrice | currency }}
              <span v-if="isOpenSeminar"> / {{ $tc('common.participant', 1) }}</span>
              <span v-else> / {{ $tc('common.day', 1) }}</span>
            </td>
            <td>{{ seminarPrice | currency }}</td>
          </tr>
          <tr v-if="offer.travelCostsIncluded">
            <td>{{ $t('pricing.travelCosts') }}</td>
            <td></td>
            <td>{{ $t('common.included') }}</td>
            <td>{{ $t('common.included') }}</td>
          </tr>
          <tr v-if="offer.documentsIncluded">
            <td>{{ $t('pricing.documents') }}</td>
            <td></td>
            <td>{{ $t('common.included') }}</td>
            <td>{{ $t('common.included') }}</td>
          </tr>
          <tr v-if="isOpenSeminar && offer.documentsIncluded">
            <td>{{ $t('pricing.catering') }}</td>
            <td>{{ duration }}</td>
            <td>{{ $t('common.included') }}</td>
            <td>{{ $t('common.included') }}</td>
          </tr>
          <tr v-if="!isOpenSeminar && offer.documentsIncluded">
            <td>{{ $t('pricing.specialistBooks') }}</td>
            <td>2 {{ $t('common.piece') }}</td>
            <td>{{ $t('common.included') }}</td>
            <td>{{ $t('common.included') }}</td>
          </tr>
          <tr
            v-for="(position, index) in additionalCostsOneTime"
            :key="'A' + index"
          >
            <td>{{ additionalCostDescription(position) }}</td>
            <td>
              <span v-if="position.perDay">{{ duration }}</span>
            </td>
            <td>
              {{ position.price | currency
              }}<span v-if="position.perDay"> / {{ $tc('common.day', 1) }}</span>
            </td>
            <td>
              {{ pricePosition(position) | currency }}
            </td>
          </tr>
          <tr>
            <td>
              <b>
                {{ summaryLocation }}
                <span v-if="!isOpenSeminar">
                  <br>{{ $t('seminarDetails.maxParticipants', { count: capacity }) }}
                </span>
              </b>
            </td>
            <td></td>
            <td></td>
            <td>
              <strong>{{ offerPrice | currency }}</strong><!-- <br />zzgl. MwSt. -->
            </td>
          </tr>
          <tr
            class="highlight-row"
            v-if="additionalCosts && additionalCostsPerPerson.length > 0"
          >
            <td><strong>{{ $t('pricing.additionalPerParticipant') }}</strong></td>
            <td><strong>{{ $t('pricing.quantity') }}</strong></td>
            <td><strong>{{ $t('pricing.unitPrice') }}</strong></td>
            <td>
              <strong v-html="$t('pricing.totalPerParticipant')"></strong>
            </td>
          </tr>
          <tr
            v-for="(position, index) in additionalCostsPerPerson"
            :key="'B' + index"
          >
            <td>{{ additionalCostDescription(position) }}</td>
            <td>
              <span v-if="position.perDay">{{ duration }}</span><span v-else>{{ $t('common.perPerson') }}</span>
            </td>
            <td>
              {{ position.price | currency }}
              <span v-if="position.perDay">/ {{ $tc('common.day', 1) }}</span><span v-else>/
                {{ $t('common.piece') }}</span>
            </td>
            <td>
              <span v-if="position.perDay">{{
                (position.price * offer.duration) | currency
                }}</span>
              <span v-else>{{ position.price | currency }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-right"><br><span v-html="$t('pricing.vatNotice')"></span></div>
      <div>
        {{ pricingException }}
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import placeholder from "./placeholder";
import { formatDuration } from "../../misc/LocaleFormat";
import { localizeAdditionalCost } from "../../misc/CombitTextClassifier";
export default {
  name: "PricingTableLegacy",
  props: {
    options: Object,
  },
  mixins: [placeholder],
  data: function () {
    return {
      renderKey: 0,
    };
  },
  computed: {
    ...mapGetters(["offer", "seminar", "offerSections"]),
    pricingException: function () {
      if (this.offer && this.offer.isRemote && this.offer.isClassroom) {
        return this.$t('pricing.remotePriceNotice');
      }
    },
    seminarTitle: function () {
      return this.seminar ? this.seminar.title : this.placeholder;
    },
    offerPrice: function () {
      return this.offer && this.offer.totalPrice
        ? this.offer.totalPrice
        : this.placeholder;
    },
    seminarPrice: function () {
      if (this.offer && parseInt(this.offer.offerType_id) === 4) {
        return this.offer.ratePerDay * this.offer.capacity;
      }
      return this.offer
        ? this.offer.ratePerDay *
        this.offer.duration *
        this.offer.numberOfExecutions
        : this.placeholder;
    },
    dailyPrice: function () {
      return this.offer ? this.offer.ratePerDay : this.placeholder;
    },
    capacity: function () {
      return this.offer ? this.offer.capacity : this.placeholder;
    },
    duration: function () {
      return this.offer && this.offer.duration
        ? formatDuration(this.offer.duration, this.offer.durationPerDay, this.offer.numberOfExecutions, this.offer.language || 'de', this.$tc.bind(this))
        : this.placeholder;
    },
    numberOfExecutions: function () {
      return this.offer ? parseInt(this.offer.numberOfExecutions) : false;
    },
    additionalCosts: function () {
      return this.offer && this.offer.additionalCosts
        ? this.offer.additionalCosts
        : [];
    },
    additionalCostsPerPerson() {
      return this.additionalCosts.filter((position) => position.perPerson);
    },
    additionalCostsOneTime() {
      return this.additionalCosts.filter((position) => !position.perPerson);
    },
    isOpenSeminar() {
      return this.offer && parseInt(this.offer.offerType_id) === 4;
    },
    isFirmenSeminar() {
      return this.offer && parseInt(this.offer.offerType_id) === 3;
    },
    summaryLocation() {
      if (this.offer.isRemote && !this.offer.isClassroom) return this.$t('pricing.locations.remote');
      if (this.offer.offerType_id === 1) return this.$t('pricing.locations.inhouse');
      return this.$t('pricing.locations.company');
    },
  },
  methods: {
    ...mapMutations(["offerSectionSet"]),
    additionalCostDescription(position) {
      return localizeAdditionalCost(position.description, this.$t.bind(this));
    },
    pricePosition(position) {
      let price = position.price;
      if (position.perDay) {
        price *= this.offer.duration || 1;
      }
      if (position.perExecution) {
        price *= this.offer.numberOfExecutions || 1;
      }
      return price;
    },
  },
  watch: {
    offer: {
      handler: function () {
        this.renderKey++;
      },
      deep: true,
    },
    seminar: function () {
      this.renderKey++;
    },
  },
};
</script>
